import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Forfaits from "../pages/forfaits/page";
import Paiement from "../pages/paiement/page";
import Compte from "../pages/compte/page";

import Bien from "../pages/bien/page";
import Comment from "../pages/comment/page";
import Contact from "../pages/contact/page";
import MentionsLegales from "../pages/mentions-legales/page";
import Admin from "../pages/admin/page";
import AdminLogin from "../pages/admin/login";
import Lot from "../pages/lot/page";
import ProtectedRoute from "../components/base/ProtectedRoute";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/forfaits", element: <Forfaits /> },
  { path: "/paiement", element: <Paiement /> },
  { path: "/compte", element: <Compte /> },

  { path: "/bien", element: <Bien /> },
  { path: "/lot/:id", element: <Lot /> },
  { path: "/comment", element: <Comment /> },
  { path: "/contact", element: <Contact /> },
  { path: "/mentions-legales", element: <MentionsLegales /> },
  
  // Administration
  { path: "/admin/login", element: <AdminLogin /> },
  { 
    path: "/admin", 
    element: (
      <ProtectedRoute>
        <Admin />
      </ProtectedRoute>
    ) 
  },
  
  { path: "*", element: <NotFound /> },
];

export default routes;
